<ng-container *transloco="let t; read: 'slots'">
  <ng-container *transloco="let tGlobal; read: 'global'">
    @if (vm$ | async; as vm) {
      <div class="xs12col componentContainer">
        <kendo-grid
          [data]="{data: vm.slots, total: vm.total}"
          [sortable]="true"
          [sort]="sort"
          (sortChange)="sortChange($event)"
          (edit)="editHandler($event)"
          (cancel)="cancelHandler($event)"
          (save)="saveHandler($event)"
          (add)="addHandler($event)"
          (remove)="showDeleteModal = $event.dataItem.id"
          [skip]="vm.gridState.skip"
          [pageSize]="vm.gridState.pageSize"
          [pageable]="true"
          [loading]="vm.loading"
          (pageChange)="pageChangeSub$.next($event)"
          [resizable]="true"
          kendoGridExpandDetailsBy="id"
          [(expandedDetailKeys)]="expandedSlotIds"
          (detailExpand)="onExpand($event.dataItem.id)"
          (detailCollapse)="onCollapse($event.dataItem.id)"
          [navigable]="true">
          @if (('Permissions.Slots.Create' | permission)) {
            <ng-template kendoGridToolbarTemplate >
              <a kendoGridAddCommand class="addIcon">
                <h2 class="padding-right-small">{{ t('title') }}</h2>
                <span class="icon">
                  <img src="../../../assets/icons/add-icon.svg">
                </span>
                {{t('add')}}
              </a>
            </ng-template>
          }
          @if (!('Permissions.SlotProducts.Create' | permission)) {
            <ng-template kendoGridToolbarTemplate >
              <h2 class="padding-right-small">{{ t('title') }}</h2>
            </ng-template>
          }
          <kendo-grid-column field="name" [title]="t('name')" media="(min-width: 993px)">
            <ng-template
              kendoGridEditTemplate
              let-isNew="isNew"
              let-formGroup="formGroup"
              >
              <kendo-textbox
                [formControl]="formGroup.get('name')"
              ></kendo-textbox>
              @if (formGroup.get('name').touched && formGroup.get('name').hasError('required') && !formGroup.get('name').value) {
                <kendo-formerror>
                {{t('isRequired')}}</kendo-formerror>
              }
              @if (formGroup.get('name').hasError('slotExists') && formGroup.get('name').touched) {
                <kendo-formerror>
                {{t('isNotUnique')}}</kendo-formerror>
              }
            </ng-template>
          </kendo-grid-column>
          <!-- MOBILE GRID -->
          <kendo-grid-column-group media="(max-width: 992px)">
            <kendo-grid-column>
              <ng-template kendoGridCellTemplate let-dataItem>
                <h4 class="mobileGridHeader">{{t('name')}}</h4>
                <span>{{dataItem.name}}</span>
              </ng-template>
              <ng-template
                kendoGridEditTemplate
                let-isNew="isNew"
                let-formGroup="formGroup">
                <h4 class="mobileGridHeader">{{t('name')}}</h4>
                <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
                @if (formGroup.get('name').touched && formGroup.get('name').hasError('required') && !formGroup.get('name').value) {
                  <kendo-formerror>
                  {{t('isRequired')}}</kendo-formerror>
                }
                @if (formGroup.get('name').hasError('slotExists') && formGroup.get('name').touched) {
                  <kendo-formerror>
                  {{t('isNotUnique')}}</kendo-formerror>
                }
              </ng-template>
            </kendo-grid-column>
          </kendo-grid-column-group>
          <kendo-grid-command-column
            [hidden]="!('Permissions.Slots.Update' | permission)">
            <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
              <a kendoGridEditCommand [attr.tooltip]="tGlobal('edit')" flow="up" class="actionIcon"><img src="../../../assets/icons/edit-icon.svg"></a>
              <a kendoGridRemoveCommand [hidden]="!('Permissions.Slots.Delete' | permission)" [attr.tooltip]="tGlobal('delete')" flow="up" class="actionIcon"><img src="../../../assets/icons/delete-icon.svg"></a>
              <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                {{ isNew ? tGlobal('add') : tGlobal('save') }}
              </button>
              <button kendoGridCancelCommand>
                {{ isNew ? tGlobal('cancel') : tGlobal('cancel') }}
              </button>
            </ng-template>
          </kendo-grid-command-column>
          <ng-template kendoGridDetailTemplate let-dataItem>
            <app-slot-product-view-admin [slot]="dataItem" [expandedSlotIds]="expandedSlotIds" [isAdmin]="isAdmin" class="subGrid xs12col flexRow flex-wrap margin-top-medium"></app-slot-product-view-admin>
          </ng-template>
          <!-- IF NO RESULTS COULD BE FOUND -->
          <ng-template kendoGridNoRecordsTemplate>
            <div class="text pl">{{t('noResults')}}</div>
          </ng-template>
          <ng-template kendoGridLoadingTemplate>
            <div class="k-loading-color"></div>
            <div class="loading-container">
              <kendo-loader type="converging-spinner" size="large"></kendo-loader>
            </div>
          </ng-template>
          <!-- Paging -->
          <ng-template
            let-totalPages="totalPages"
            let-currentPage="currentPage"
            kendoPagerTemplate>
            <div class="width100 flex -spaceAround -alignCenter mts  margin-bottom-medium flex-wrap">
              <div class="flex">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-numeric-buttons
                  [buttonCount]="5"
                ></kendo-pager-numeric-buttons>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
              <div class="flex -alignCenter">
                <kendo-buttongroup
                  [selection]="'single'"
                  id="pageBtnGroup"
                  class="-purple">
                  <button
                                    (click)="
                                    pageChangeSub$.next({
                                        skip: vm.gridState.skip,
                                        take: pageSizes.Small
                                    })
                                    "
                    kendoButton
                    [selected]="vm.gridState.pageSize === pageSizes.Small"
                    [toggleable]="true"
                    >
                    {{ pageSizes.Small }}
                  </button>
                  <button
                                    (click)="
                                    pageChangeSub$.next({
                                        skip: vm.gridState.skip,
                                        take: pageSizes.Medium
                                    })
                                    "
                    kendoButton
                    [selected]="vm.gridState.pageSize === pageSizes.Medium"
                    [toggleable]="true"
                    >
                    {{ pageSizes.Medium }}
                  </button>
                  <button
                                    (click)="
                                    pageChangeSub$.next({
                                        skip: vm.gridState.skip,
                                        take: pageSizes.Large
                                    })
                                    "
                    kendoButton
                    [selected]="vm.gridState.pageSize === pageSizes.Large"
                    [toggleable]="true"
                    >
                    {{ pageSizes.Large }}
                  </button>
                </kendo-buttongroup>
              </div>
            </div>
          </ng-template>
        </kendo-grid>
        @if (showDeleteModal) {
          <kendo-window
            [title]="t('deleteConfirmationTitle')"
            (close)="showDeleteModal = null"
            [minWidth]="250"
            [width]="450">
            <!-- Confirmation Pop-Up -->
            <kendo-window-titlebar>
              <h2>{{t('deleteConfirmationTitle')}}</h2>
              <button kendoWindowCloseAction></button>
            </kendo-window-titlebar>
            <p>{{t('deleteConfirmationMessage')}}</p>
            <button
              kendoButton
              class="mrm"
              (click)="showDeleteModal = null">
              {{t('cancel')}}
            </button>
            <button
              kendoButton
              class="error"
              (click)="onDelete(showDeleteModal)">
              {{t('delete')}}
            </button>
          </kendo-window>
        }
      </div>
    }
  </ng-container>
</ng-container>